import React, { Component } from "react";
import { isDesktop } from "react-device-detect";
import { FiChevronLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import Image from "../../../../base/features/micro/Image";
import checkLength from "../../../../base/utils/check_length";
import { getProductId, getShopUid } from "../../../../settings/domainManager";
import { navigate_to_product } from "../../../../navigator/user/product";

class SameProductsBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="row px-4 mt-3 mx-0 mb-4">
        <div className={`col-6 fs-5 px-0 fw-bold`}>{this.props.title}</div>
        <div className={`col-6 text-start align-self-center px-0`}>
          <Link
            className="fw-bold text-muted small"
            to={`/search/product?same=${
              this.props.products[0].shop ? getProductId() : ""
            }&shop=${!this.props.products[0].shop ? getShopUid() : ""}`}
          >
            بیشتر
            <FiChevronLeft className="me-2" />
          </Link>
        </div>
        <div
          style={{
            overflow: "scroll hidden",
            whiteSpace: "nowrap",
          }}
          className="px-0 py-3 col-12 scrollbar-hide"
        >
          {this.props.products.map((product, p) => (
            <div
              className="d-inline-block p-0 bg-white shadow-sm rounded14 ms-3 align-top h-100"
              style={{ width: isDesktop ? "30%" : "50%" }}
            >
              <Link
                to={navigate_to_product(
                  product.shop ? product.shop.uid : getShopUid(),
                  product.id
                )}
              >
                <Image
                  imageUri={product.image && product.image.file}
                  imageHeight={"140"}
                  imgClassName="w-100 d-block img-cover rounded-top-14"
                  extraClassName="w-50 d-block rounded14 p-2 mx-auto bg-secondary"
                />
                <div
                  className="px-2 pb-3"
                  style={{ whiteSpace: "break-spaces" }}
                >
                  <p className="mt-2 fw fs-6 mb-0">
                    {checkLength(product.name, 38)}
                  </p>
                  {product.shop && (
                    <p className="mb-2 small text-muted fw-bold">
                      {product.shop.title}
                    </p>
                  )}
                  <p
                    className="fw-bold mb-0 small"
                    style={{ color: product.payable_price.color }}
                  >
                    <span>{product.payable_price.title}</span>
                    <span className="fs-7 me-1">
                      {product.payable_price.currency}
                    </span>
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default SameProductsBlock;
